import { createContext as e } from "react";
const o = /* @__PURE__ */ e(!1);
export {
  o as C
};
//# sourceMappingURL=__utils-9dae8b32.js.map
